import React, { useState } from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const PlayButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 69 69" fill="none">
    <circle cx="34.2143" cy="34.2143" r="34.2143" fill="#FF541C"/>
    <path d="M47.5454 31.616C49.5454 32.7707 49.5454 35.6574 47.5454 36.8121L29.8006 47.0571C27.8006 48.2118 25.3006 46.7684 25.3006 44.459L25.3006 23.9691C25.3006 21.6597 27.8006 20.2163 29.8006 21.371L47.5454 31.616Z" fill="white"/>
  </svg>
);

const QuoteOpen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 26 21" fill="none">
    <path d="M15.4456 5.00351C16.5333 3.26316 17.8386 1.9579 19.3614 1.08772C20.5217 0.362573 21.8088 0 23.2228 0C24.1655 0 24.6369 0.253801 24.6369 0.761404C24.6369 0.978948 24.4374 1.16023 24.0386 1.30526C22.4433 1.92164 21.1743 3.04562 20.2316 4.6772C19.4702 5.98246 19.0351 7.28772 18.9263 8.59299C19.1439 8.55673 19.4702 8.5386 19.9053 8.5386C23.7848 8.5386 25.7246 10.4784 25.7246 14.3579C25.7246 18.2374 23.7848 20.1772 19.9053 20.1772C17.9474 20.1772 16.3702 19.5246 15.1737 18.2193C13.8322 16.8415 13.1614 14.9924 13.1614 12.6719C13.1614 9.88012 13.9228 7.32398 15.4456 5.00351ZM2.28421 5.00351C3.37193 3.26316 4.6772 1.9579 6.2 1.08772C7.36024 0.362573 8.64737 0 10.0614 0C11.0041 0 11.4754 0.253801 11.4754 0.761404C11.4754 0.978948 11.276 1.16023 10.8772 1.30526C9.28188 1.92164 8.01287 3.04562 7.07018 4.6772C6.30878 5.98246 5.87369 7.28772 5.76492 8.59299C5.98246 8.55673 6.30878 8.5386 6.74386 8.5386C10.6234 8.5386 12.5632 10.4784 12.5632 14.3579C12.5632 18.2374 10.6234 20.1772 6.74386 20.1772C4.78597 20.1772 3.20877 19.5246 2.01228 18.2193C0.670761 16.8415 0 14.9924 0 12.6719C0 9.88012 0.761404 7.32398 2.28421 5.00351Z" fill="#FF541C"/>
  </svg>
);

const QuoteClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 26 21" fill="none">
    <path d="M10.279 15.1737C9.19127 16.9141 7.886 18.2193 6.36319 19.0895C5.20296 19.8147 3.91582 20.1772 2.50179 20.1772C1.5591 20.1772 1.08775 19.9234 1.08775 19.4158C1.08775 19.1983 1.28717 19.017 1.686 18.872C3.28132 18.2556 4.55033 17.1316 5.49302 15.5C6.25442 14.1948 6.68951 12.8895 6.79828 11.5843C6.58074 11.6205 6.25442 11.6386 5.81933 11.6386C1.9398 11.6386 3.14336e-05 9.69887 3.17728e-05 5.81934C3.21119e-05 1.93981 1.9398 3.7975e-05 5.81934 3.83141e-05C7.77723 3.84853e-05 9.35443 0.65267 10.5509 1.95793C11.8924 3.33571 12.5632 5.18484 12.5632 7.50531C12.5632 10.2971 11.8018 12.8533 10.279 15.1737ZM23.4404 15.1737C22.3527 16.9141 21.0474 18.2193 19.5246 19.0895C18.3644 19.8147 17.0772 20.1772 15.6632 20.1772C14.7205 20.1772 14.2492 19.9234 14.2492 19.4158C14.2492 19.1983 14.4486 19.017 14.8474 18.872C16.4427 18.2556 17.7117 17.1316 18.6544 15.5C19.4158 14.1948 19.8509 12.8895 19.9597 11.5843C19.7422 11.6205 19.4158 11.6386 18.9807 11.6386C15.1012 11.6386 13.1614 9.69888 13.1614 5.81934C13.1614 1.93981 15.1012 3.91256e-05 18.9807 3.94648e-05C20.9386 3.96359e-05 22.5158 0.652672 23.7123 1.95794C25.0539 3.33571 25.7246 5.18484 25.7246 7.50531C25.7246 10.2971 24.9632 12.8533 23.4404 15.1737Z" fill="#FF541C"/>
  </svg>
);

const getVideoId = (url) => {
  if (!url) return "";
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/))([-\w]+)/);
  return match ? match[1] : "";
};

const BruceSection = ({ data }) => {
  const [playing, setPlaying] = useState(false);
  const imgPath = process.env.REACT_APP_IMAGES;

  if (!data) return null;

  const videoId = getVideoId(data.videoUrl);

  return (
    <section className="bruce-section section-spacing">
      <Container>
        <div className="bruce-video-wrapper video-glow">
          <span className="video-glow-blob-1" />
          <span className="video-glow-blob-2" />
          <div className="bruce-thumb-click" onClick={() => !playing && setPlaying(true)} role="button" tabIndex={0} aria-label="Play video">
            <img
              src={`${imgPath}${data.thumbnail}`}
              alt="Bruce Buffer announces Pavan Agarwal"
              className="bruce-thumbnail"
              loading="lazy"
            />
            {!playing && (
              <span className="bruce-play-btn">
                <PlayButton />
              </span>
            )}
            {playing && (
              <>
                <div className="video-loading-spinner" />
                <iframe
                  className="bruce-iframe video-iframe-overlay"
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                  title="Bruce Buffer Announcement"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  frameBorder="0"
                />
                <button className="bruce-close-btn" onClick={(e) => { e.stopPropagation(); setPlaying(false); }} aria-label="Close video">✕</button>
              </>
            )}
          </div>
         </div>

        <div className="bruce-quote-block">
          <span className="bruce-quote-open"><QuoteOpen /></span>
          <p className="bruce-quote-text">{parse(data.quote)}</p>
          <span className="bruce-quote-close"><QuoteClose /></span>
        </div>

        <div className="bruce-attribution">
          <p className="bruce-name">{parse(data.name)} <span className="bruce-title">{parse(data.title)}</span></p>
           
        </div>
      </Container>
    </section>
  );
};

export default BruceSection;
